import {Component} from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'kt-converstion-not-found',
    templateUrl: './conversation-not-found.dialog.component.html'
})
export class ConversationNotFoundDialogComponent {

    constructor(
        private router: Router,
    ) {
    }

    onClick() {
        this.router.navigate(['/dashboard']);
    }
}
